module.exports = {"522628100":"三江镇","522628101":"茅坪镇","522628102":"敦寨镇","522628103":"启蒙镇","522628104":"平秋镇","522628105":"铜鼓镇","522628106":"平略镇","522628200":"大同乡","522628201":"新化乡","522628202":"隆里乡","522628203":"钟灵乡","522628204":"偶里乡","522628205":"固本乡","522628206":"河口乡","522628207":"彦洞乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/522628.json
// module id = 2517
// module chunks = 0